import styles from './section.css';

<template>
  <section class={{styles.section}} ...attributes>
    {{yield}}
  </section>
</template>
